import { apiConstants } from './shared/config';

const routes = [
    {
        path: `/${apiConstants.code}/:appCode/home`,
        name: `${apiConstants.code}.home`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "app-home" */ './views/home.vue'),
        meta: {
            title: 'Home',
            auth: undefined,
        },
    },
];

export default routes;